export default __webpack_public_path__ + "static/media/deli_car.41f24681.png";